export class AccountUserSettings {
  id: string;
  canAccessAccounts: boolean;
  personId: string;
}
